var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 26.5,
    height: 26.5,
    rx: 13.25,
    fill: "#5C7AFF",
    stroke: "#5C7AFF",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 9.726a5.803 5.803 0 0 1-1.65.445 2.849 2.849 0 0 0 1.264-1.563 5.824 5.824 0 0 1-1.826.686 2.884 2.884 0 0 0-2.096-.894c-1.586 0-2.871 1.267-2.871 2.828 0 .222.025.437.074.644a8.196 8.196 0 0 1-5.92-2.954c-.255.43-.39.921-.388 1.421 0 .98.508 1.848 1.278 2.354a2.906 2.906 0 0 1-1.302-.354v.035a2.842 2.842 0 0 0 2.304 2.772 2.952 2.952 0 0 1-1.298.047 2.869 2.869 0 0 0 2.683 1.964 5.818 5.818 0 0 1-3.567 1.21c-.231 0-.46-.014-.685-.04a8.208 8.208 0 0 0 4.402 1.273c5.283 0 8.171-4.309 8.171-8.047l-.01-.367A5.689 5.689 0 0 0 21 9.726Z",
    fill: "#fff"
  })));
};

export default SvgTwitter;